import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import BrandLogoGifImage from '../../assets/imgs/brand-logo.gif'
import { DashboardLayout, SocialMediaIcons } from '../../components'
import { isDesktop } from '../../utils'

import './DashboardHome.scss'

const DashboardHome = () => {
   const { isDarkTheme } = useSelector(state => state.theme)

   if (isDesktop()) {
      return (
         <DashboardLayout>
            <div
               className={clsx(
                  'DesktopDashboardHome',
                  isDarkTheme && 'DesktopDashboardHome--dark'
               )}
            >
               <div className="DesktopDashboardHome__card">
                  <h1 className="DesktopDashboardHome__heading">
                     Welcome
                     <br /> <span>WallStreetNinja</span> Suite User!
                  </h1>
                  <div className="DesktopDashboardHome__logo-container">
                     <img
                        className="DesktopDashboardHome__logo"
                        src={BrandLogoGifImage}
                        alt="WSN"
                     />
                  </div>
                  <h2 className="DesktopDashboardHome__tagline">
                     The Unstoppable Finance Suite
                  </h2>
               </div>
            </div>
         </DashboardLayout>
      )
   }

   return (
      <DashboardLayout
         className={clsx('DashboardHome', isDarkTheme && 'DashboardHome--dark')}
      >
         <h1 className="DashboardHome__heading">
            Welcome
            <br /> WallStreetNinja
            <br /> Suite User!
         </h1>
         <div className="DashboardHome__logo-container">
            <img
               className="DashboardHome__logo"
               src={BrandLogoGifImage}
               alt="WSN"
            />
         </div>
         <h1 className="DashboardHome__tagline">
            The <br />
            Unstoppable
            <br /> Finance Suite
         </h1>
         <SocialMediaIcons className="DashboardHome__social" />
      </DashboardLayout>
   )
}

export default DashboardHome
